import API from './../api';

export default {

    namespaced: true,

    state() {
        return {
            guestEdit: false,
            property: false,
            reservationDelete: false,
            reservationEdit: false,
            reservationView: false,
        };
    },

    getters: {
        guestEdit: (state) => state.guestEdit,
        reservationCancel: (state) => state.reservationCancel,
        reservationDelete: (state) => state.reservationDelete,
        reservationEdit: (state) => state.reservationEdit,
        reservationView: (state) => state.reservationView,
    },

    mutations: {
        gotPermissions(state, response) {
            const {data} = response
            state.guestEdit = data.guest_edit;
            state.reservationCancel = data.reservation_cancel;
            state.reservationDelete = data.reservation_delete;
            state.reservationEdit = data.reservation_edit;
            state.reservationView = data.reservation_view;
        },
    },

    actions: {
        async fetchPermissions({commit}) {
            commit('gotPermissions', await API.get('/app/reservations-list/reservations/permissions/'));
        }
    },

};
